import { ReactElement, ReactNode, useState } from 'react'
import {
  Card,
  CardActions,
  CardContent,
  FormControlLabel,
  Switch,
} from '@mui/material'
import './DevelopusSwitchCard.css'

interface Props {
  children: ReactNode
  checked: boolean
  switchable: boolean
  ribbonText?: string
  onEnable?: () => void
  onDisable?: () => void
}

const DevelopusSwitchCard = (props: Props): ReactElement => {
  const [checked, setChecked] = useState<boolean>(props.checked)

  const handleSwitch = () => {
    setChecked(!checked)

    if (checked === false) {
      if (props.onEnable !== undefined) {
        props.onEnable()
      }
    } else {
      if (props.onDisable !== undefined) {
        props.onDisable()
      }
    }
  }

  const ribbonExists = props.ribbonText !== undefined

  return (
    <Card className="card-with-ribbon">
      {ribbonExists && <div className="ribbon"> {props.ribbonText} </div>}
      <CardContent sx={{ opacity: checked ? 1 : 0.2 }}>
        {props.children}
      </CardContent>
      <CardActions sx={{ justifyContent: 'flex-end', width: '100%' }}>
        <FormControlLabel
          disabled={!props.switchable}
          control={<Switch checked={checked} onClick={handleSwitch} />}
          labelPlacement="start"
          label=""
        />
      </CardActions>
    </Card>
  )
}

export default DevelopusSwitchCard
